import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToolbarModule } from 'primeng/toolbar';
import { DatePickerModule } from 'primeng/datepicker';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { DataViewModule } from 'primeng/dataview';
import { NgxBarcode6 } from 'ngx-barcode6';

import { TagModule } from 'primeng/tag';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';

import { CheckboxModule } from 'primeng/checkbox';
import { PopoverModule } from 'primeng/popover';

import { IconFieldModule } from 'primeng/iconfield';
import { TooltipModule } from 'primeng/tooltip';

import { InputIconModule } from 'primeng/inputicon';
import { MenuModule } from 'primeng/menu';
import { CardModule } from 'primeng/card';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ChipModule } from 'primeng/chip';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { DividerModule } from 'primeng/divider';
import { FieldsetModule } from 'primeng/fieldset';
import { TimelineModule } from 'primeng/timeline';
import { TabsModule } from 'primeng/tabs';
export const PRIMENG_MODULES = [ButtonModule,
  ProgressSpinnerModule,
  DatePickerModule,
  MenubarModule,
  InputTextModule,
  FloatLabelModule,
  TableModule,
  DataViewModule,
  TagModule,
  CheckboxModule,
  SelectModule,
  FormsModule,
  CommonModule,
  ReactiveFormsModule,
  ToastModule,
  ConfirmDialogModule,
  NgxBarcode6,
  PopoverModule,
  DialogModule,
  ToolbarModule,
  IconFieldModule,
  TooltipModule,
  InputIconModule,
  MenuModule,
  CardModule,
  AvatarGroupModule,
  AvatarModule,
  ChipModule,
  MultiSelectModule,
  ToggleSwitchModule,
  DividerModule,
  FieldsetModule,
  TimelineModule,
  TabsModule]

